import { render, staticRenderFns } from "./PcStaticFieldValue.vue?vue&type=template&id=80927ff0"
import script from "./PcStaticFieldValue.vue?vue&type=script&lang=js"
export * from "./PcStaticFieldValue.vue?vue&type=script&lang=js"
import style0 from "./PcStaticFieldValue.vue?vue&type=style&index=0&id=80927ff0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
